module.exports = __webpack_public_path__ + "fd22569e4bcf8d2e6b7e8b9cccb4e266.svg";